import {createGlobalStyle} from 'styled-components';

import {scrollBar} from '../../../shared-components/mixin/scroll/scrollBar';
import {colorTheme} from '../../mixin/colorTheme';

export const FormSelectListGlobalStyle = createGlobalStyle`
    :root {
        ${colorTheme({
            '--select-dropdown-container': {dark: '#35393D', light: '#FFFFFF'},
            '--select-dropdown-option-background-hover': {dark: '#495166', light: '#e6f6ff'},
            '--select-dropdown-option-text-hover': {dark: '#35393D', light: '#FFFFFF'},
            '--select-dropdown-option-background-selected': {dark: '#2087BD', light: '#2087BD'},
            '--select-dropdown-option-background-selected-hover': {dark: ' #036b9e', light: ' #036b9e'},

            '--select-container-shadow': {
                dark: ' 0 0 24px -4px var(--black-02);',
                light: '-2px -2px 2px 0px #28368205, 1px 1px 11px -3px #102c4954;',
            },
        })};
    }
    .form-select__menu-portal {
        z-index: 9999 !important;
        
    }
    .form-select__menu-list{
        padding: var(--space-xsm)!important;
    }

    .form-select__menu {
        overflow: hidden !important;
    }
    .form-select__menu,
    .form-select__menu-list,
    .form-select__menu-list--is-multi 
    {
        background: var(--select-dropdown-container) !important;
        border: 1px solid var(--container-border-color-500);
    }

    .form-select__menu{
        border: none;
        box-shadow: var(--container-shadow-color-100)!important;
        border-radius: 12px !important;
        z-index: 9;
    }
    .form-select__menu-list,
    .form-select__menu-list--is-multi {
        ${scrollBar};
        padding: var(--space-sm);
        border-radius: 12px !important;
        color: var(--default-text-color)!important;
        line-height: 20px;
    }
    .form-select__option {
        padding: var(--space) var(--space-sm)!important;
        color: var(--default-text-color)!important;
        margin-bottom: 2px;
    }

    .form-select__option.form-select__option--is-focused,
    .form-select__option.form-select__option--is-selected {
        border-radius: 8px !important;
    }

    .form-select__option.form-select__option--is-disabled {
        background: var(--container-background-color-disabled-100);
        color: var(--label-text-color-100)!important;
        border-radius: 8px;
        cursor: not-allowed;
    }

    .form-select__option.form-select__option--is-focused {
        background: var(--select-dropdown-option-background-hover)!important;
    }

    .form-select__option.form-select__option--is-selected {
        background: var(--select-dropdown-option-background-selected)!important;
        color: white!important;
        &:hover { 
            background: var(--select-dropdown-option-background-selected-hover)!important;
        }
    }
`;
